import { isNumber } from 'radash';

import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import { Diagram, Zone, ZoneValidationError, ZoneValidationErrorType } from 'models';

type Props = { diagram: Diagram; zones: Zone[]; controlZones: Zone[] };

const checkFaultEndpointCapacitanceVoltage = ({ diagram, zones, controlZones }: Props) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((faultZone) => {
        const controlZone = controlZones.find((cz) => cz.id === faultZone.id);
        if (!controlZone) return;

        let zoneHasVoltage = false;
        let zoneHasCapacitance = false;
        const endpointsWithIssues: string[] = [];

        controlZone.connections.forEach((connection) => {
            const { from, to } = connection;

            [from, to].forEach((endpoint) => {
                if (!isNumber(endpoint.port)) return;

                const componentInstance = diagram.componentInstances[endpoint.componentInstanceId];
                if (!componentInstance) return;

                if (!ZoneHelpers.isControlZoneEndpoint(componentInstance, endpoint.port)) return;

                if (!endpointsWithIssues.includes(endpoint.componentInstanceId)) {
                    endpointsWithIssues.push(endpoint.componentInstanceId);
                }

                const portSpec = componentInstance.specifications.electrical.ports[endpoint.port];
                if (!portSpec) return;

                const voltageType = componentInstance.configuration.ports[endpoint.port]?.voltageType ?? null;
                if (!voltageType) return;

                // @ts-ignore
                const voltage = voltageType in portSpec ? portSpec[voltageType]?.voltage : null;
                const hasVoltage = voltage && (voltage.min || voltage.nom || voltage.max);
                const hasCapacitance = 'capacitance' in portSpec && portSpec.capacitance.nom;

                if (hasVoltage) zoneHasVoltage = true;
                if (hasCapacitance) zoneHasCapacitance = true;
            });
        });

        if (endpointsWithIssues.length === 0) return;

        const affectedComponents = faultZone.componentInstances.filter((ci) => endpointsWithIssues.includes(ci.id));

        if (!zoneHasVoltage) {
            ZoneHelpers.error(
                errors,
                ZoneValidationErrorType.FAULT_ENDPOINT_VOLTAGE_MISSING,
                faultZone,
                affectedComponents,
            );
        }

        if (!zoneHasCapacitance) {
            ZoneHelpers.error(
                errors,
                ZoneValidationErrorType.FAULT_ENDPOINT_CAPACITANCE_MISSING,
                faultZone,
                affectedComponents,
            );
        }
    });

    return errors;
};

export { checkFaultEndpointCapacitanceVoltage };
